export default __webpack_public_path__ + "static/media/stage_pickup.58277295.svg";